import React, { useRef } from "react";
import { Typography, Button, Box } from "@mui/material";
import { styled } from "@mui/system";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import TitreTypography from "./Typography/TitreTypography";
import SousTitreTypography from "./Typography/SousTitreTypography";

export const ImportButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#E9535D",
  color: "white",
  "&:hover": {
    backgroundColor: "#EF8192",
  },
  borderRadius: "16px",
  height: "50px",
  zIndex: 10,
  padding: theme.spacing(1),

  // 🔹 النصوص
  fontFamily: "Mulish, sans-serif",
  fontWeight: 600, // SemiBold = 600
  fontStyle: "normal", // SemiBold ماشيش في CSS
  fontSize: "16px",
  lineHeight: "22px",
  letterSpacing: "0px",
  textAlign: "center",
  verticalAlign: "middle",
  textTransform: "none", // يمنع CAPITALIZE الافتراضي
}));

const TextStyle = {
  marginTop: "5%",
  fontWeight: "bold",
  fontSize: "2rem",
};

const PhotoImportCard = ({ AddImage, affichage, event = false }) => {
  const fileInputRef = useRef(null);
  const cameraInputRef = useRef(null);

  const handleButtonClick = () => {
    if (event) {
      // If it's an event, open the camera input
      cameraInputRef.current.click();
    } else {
      // Otherwise, open the file input for gallery selection
      fileInputRef.current.click();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderColor: "#f7f7f7",
        textAlign: "center",
        padding: "20px",
        gap: "20px",
      }}
    >
      {affichage && (
        <>
          <Typography
            sx={{
              fontFamily: "F37 Ginger, sans-serif",
              fontWeight: 700,
              fontStyle: "normal",
              fontSize: "20px",
              lineHeight: "100%",
              letterSpacing: "0",
              textAlign: "center",
              verticalAlign: "bottom",
              color: "#32324D",
            }}
          >
            Choisissez <br />
            vos photos préférées! 🔥
          </Typography>

          <Typography
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 500, // Medium = 500
              fontStyle: "normal", // "Medium" ماشيش في CSS
              fontSize: "18px",
              lineHeight: "100%", // 100% من حجم الخط
              letterSpacing: "0",
              textAlign: "center",
              verticalAlign: "bottom", // غالباً ما يفيد داخل flex
              color: "#8E8EA9",
            }}
          >
            Nous acceptons les fichiers JPEG, JPG, PNG et HEIC (seulement sur
            iOS et MacOS), jusqu'à 100 Mo.
          </Typography>
        </>
      )}

      <ImportButton
        sx={{ marginTop: "50px" }}
        variant="contained"
        onClick={handleButtonClick}
        //startIcon={<AddPhotoAlternateIcon />}
        fullWidth
      >
        Importer des photos
      </ImportButton>

      {/* File Input for selecting from gallery */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/*"
        multiple
        onChange={AddImage}
      />

      {/* File Input for taking a photo */}
      <input
        type="file"
        ref={cameraInputRef}
        style={{ display: "none" }}
        accept="image/*"
        capture="environment"
        onChange={AddImage}
      />
    </Box>
  );
};

export default PhotoImportCard;
